import { render, staticRenderFns } from "./KalenderAkademik.vue?vue&type=template&id=fe744270"
import script from "./KalenderAkademik.vue?vue&type=script&lang=js"
export * from "./KalenderAkademik.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports